__turbopack_context__.v({
  "action": "PortalProfileMenu-module__xP0drq__action",
  "appearance": "PortalProfileMenu-module__xP0drq__appearance",
  "appearanceChoice": "PortalProfileMenu-module__xP0drq__appearanceChoice",
  "appearanceOptions": "PortalProfileMenu-module__xP0drq__appearanceOptions",
  "avatar": "PortalProfileMenu-module__xP0drq__avatar",
  "avatarLarge": "PortalProfileMenu-module__xP0drq__avatarLarge",
  "chevron": "PortalProfileMenu-module__xP0drq__chevron",
  "identity": "PortalProfileMenu-module__xP0drq__identity",
  "language": "PortalProfileMenu-module__xP0drq__language",
  "logout": "PortalProfileMenu-module__xP0drq__logout",
  "onTopbar": "PortalProfileMenu-module__xP0drq__onTopbar",
  "panel": "PortalProfileMenu-module__xP0drq__panel",
  "profile-in": "PortalProfileMenu-module__xP0drq__profile-in",
  "root": "PortalProfileMenu-module__xP0drq__root",
  "trigger": "PortalProfileMenu-module__xP0drq__trigger",
});
